/**
 * @prettier
 */
import * as React from 'react';

export function PaymentCashIcon({ title }: Props): React.ReactElement {
    return (
        <svg width='35' height='35' viewBox='0 0 35 35' fill='none' xmlns='http://www.w3.org/2000/svg'>
            {title && <title>{title}</title>}
            <rect width='35' height='35' rx='17.5' fill='#F1F1F1' />
            <path
                d='M19.7038 16.8778C19.2894 16.4634 18.5597 16.1752 17.889 16.1571M17.889 16.1571C17.091 16.1357 16.3766 16.4967 16.3766 17.4827C16.3766 19.2975 19.7038 18.3901 19.7038 20.2049C19.7038 21.24 18.8183 21.6847 17.889 21.6513M17.889 16.1571V15.063M16.0741 20.8099C16.464 21.3297 17.1889 21.6262 17.889 21.6513M17.889 21.6513V22.9272M8.86669 24.137V13.9741C8.86669 13.7736 9.1592 13.6111 9.52002 13.6111H27.0356C27.3964 13.6111 27.6889 13.7736 27.6889 13.9741V24.137C27.6889 24.3375 27.3964 24.5 27.0356 24.5H9.52002C9.1592 24.5 8.86669 24.3375 8.86669 24.137Z'
                stroke='#616B79'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M24.7852 19.4185C24.7852 19.8194 24.4602 20.1444 24.0593 20.1444C23.6583 20.1444 23.3333 19.8194 23.3333 19.4185C23.3333 19.0176 23.6583 18.6926 24.0593 18.6926C24.4602 18.6926 24.7852 19.0176 24.7852 19.4185Z'
                fill='#616B79'
            />
            <path
                d='M13.2222 19.4185C13.2222 19.8194 12.8972 20.1444 12.4963 20.1444C12.0953 20.1444 11.7703 19.8194 11.7703 19.4185C11.7703 19.0176 12.0953 18.6926 12.4963 18.6926C12.8972 18.6926 13.2222 19.0176 13.2222 19.4185Z'
                fill='#616B79'
            />
            <path
                d='M8.86667 21.3889H7.96444C7.60362 21.3889 7.31111 21.2264 7.31111 21.0259V10.863C7.31111 10.6625 7.60362 10.5 7.96444 10.5H25.48C25.8409 10.5 26.1333 10.6625 26.1333 10.863V13.4731'
                stroke='#616B79'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
}
type Props = {
    title?: string;
};
